import { FormControlLabel, Switch, useTheme } from '@mui/material';
import React from 'react';
import linkedAccountsSectionStyles from '../Accounts/LinkedAccountsSection.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { keyboardFocusVisibleSx } from '../../utils/a11y.utils';

function SelectAll(props) {
	const { t } = useTranslation();
	const theme = useTheme();

	if (props.consentsNum <= 1) {
		return null;
	}

	return (
		<FormControlLabel
			control={
				<Switch
					checked={props.selectAll}
					onChange={props.toggleSelectAll}
					sx={keyboardFocusVisibleSx}
				/>
			}
			label={t('common.buttons.selectAll')}
			sx={{
				...linkedAccountsSectionStyles.changeNumberLink,
				m: 0,
				color: theme.palette.primary.main,
				'& .MuiFormControlLabel-label': {
					fontSize: 'inherit',
				},
			}}
		/>
	);
}

export default SelectAll;
